/** Shared failure messages for each classified failure kind, so errors follow the chosen language. */
export const failureEn={
 "failure.session_expired":"Your session needs to be renewed. Your work is preserved.",
 "failure.access_revoked":"You no longer have access to this. Your work is preserved.",
 "failure.invalid_input":"Some information needs correction. Your work is preserved.",
 "failure.query_restart":"The list needs to reload from the start.",
 "failure.revision_conflict":"This record changed. Review the latest version before saving again.",
 "failure.not_found":"This record is no longer available.",
 "failure.rate_limited":"Too many requests. Wait before trying again.",
 "failure.network":"You appear to be offline. Your work is preserved.",
 "failure.service_unavailable":"The service is temporarily unavailable. Your work is preserved.",
 "failure.ambiguous_outcome":"The outcome is not confirmed. Check the latest state before trying again.",
 "failure.cancelled":"Cancelled.",
 "failure.unknown":"The request could not be completed. Your work is preserved."
};
export const failureRu:Record<keyof typeof failureEn,string>={
 "failure.session_expired":"Нужно обновить сеанс. Ваши данные сохранены.",
 "failure.access_revoked":"У вас больше нет доступа к этому. Ваши данные сохранены.",
 "failure.invalid_input":"Некоторые данные нужно исправить. Ваши данные сохранены.",
 "failure.query_restart":"Список нужно загрузить заново с начала.",
 "failure.revision_conflict":"Запись изменилась. Проверьте последнюю версию перед сохранением.",
 "failure.not_found":"Эта запись больше недоступна.",
 "failure.rate_limited":"Слишком много запросов. Подождите и повторите.",
 "failure.network":"Похоже, нет подключения к сети. Ваши данные сохранены.",
 "failure.service_unavailable":"Сервис временно недоступен. Ваши данные сохранены.",
 "failure.ambiguous_outcome":"Результат не подтверждён. Проверьте текущее состояние перед повтором.",
 "failure.cancelled":"Отменено.",
 "failure.unknown":"Не удалось выполнить запрос. Ваши данные сохранены."
};
export const failureKo:Record<keyof typeof failureEn,string>={
 "failure.session_expired":"세션을 갱신해야 합니다. 작업 내용은 보존됩니다.",
 "failure.access_revoked":"더 이상 이 항목에 접근할 수 없습니다. 작업 내용은 보존됩니다.",
 "failure.invalid_input":"일부 정보를 수정해야 합니다. 작업 내용은 보존됩니다.",
 "failure.query_restart":"목록을 처음부터 다시 불러와야 합니다.",
 "failure.revision_conflict":"이 기록이 변경되었습니다. 저장하기 전에 최신 버전을 확인하세요.",
 "failure.not_found":"이 기록은 더 이상 사용할 수 없습니다.",
 "failure.rate_limited":"요청이 너무 많습니다. 잠시 후 다시 시도하세요.",
 "failure.network":"오프라인 상태인 것 같습니다. 작업 내용은 보존됩니다.",
 "failure.service_unavailable":"서비스를 일시적으로 사용할 수 없습니다. 작업 내용은 보존됩니다.",
 "failure.ambiguous_outcome":"결과가 확인되지 않았습니다. 다시 시도하기 전에 최신 상태를 확인하세요.",
 "failure.cancelled":"취소되었습니다.",
 "failure.unknown":"요청을 완료할 수 없습니다. 작업 내용은 보존됩니다."
};
